var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloud = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.53 5.801C4.9 3.761 6.755 2.25 8.93 2.25c2.432 0 4.464 1.89 4.464 4.295 0 .416-.062.818-.176 1.198 1.171.407 2.033 1.484 2.033 2.791 0 1.67-1.408 2.966-3.071 2.966H4.75c-2.176 0-4-1.692-4-3.852C.75 7.56 2.453 5.91 4.53 5.8zm1.434.743v.03a.75.75 0 0 1-.851.746 2.682 2.682 0 0 0-.363-.025c-1.414 0-2.5 1.086-2.5 2.353C2.25 10.914 3.336 12 4.75 12h7.429c.9 0 1.571-.689 1.571-1.466 0-.776-.67-1.465-1.57-1.466h-.03a.75.75 0 0 1-.646-1.138c.248-.41.389-.881.389-1.385 0-1.51-1.294-2.795-2.964-2.795S5.965 5.033 5.964 6.544z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloud);
export default ForwardRef;